import { Component, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import type { OnyxIconName } from '../interfaces';

@Component({
  selector: 'onyx-custom-icon',
  imports: [SvgIconComponent],
  templateUrl: './onyx-custom-icon.component.html',
  styleUrl: './onyx-custom-icon.component.scss',
})
export class OnyxCustomIconComponent {
  public readonly source = input.required<string>();
  public readonly name = input<OnyxIconName>();
  public readonly size = input.required<number>();
}
